import IntercomService from '../service/IntercomService';

class FatalErrorUsecase {
  private readonly intercomService: IntercomService;

  constructor({ intercomService }: { intercomService: IntercomService }) {
    this.intercomService = intercomService;
  }

  public requestContact = (): void => {
    this.intercomService.openNewMessage();
  };
}

export default FatalErrorUsecase;
